<template>
  <div class="vision-page">
    <div class="header-wrap app-flex-mid-center">
      <div class="image-wrap">
        <img src="../../../assets/area/vis1.png" class="bg" />
      </div>
      <div class="text-wrap">
        <base-text title="智能视觉，方便快捷" color="#fff" shadow-color="rgba(255,255,255, 0.3)" type="large"></base-text>
      </div>
    </div>

    <div class="main">
      <base-title title="智能视觉" rich-title="Intelligent vision"></base-title>
      <div class="desc-cont">
        <div class="article-section">
          我司立足于航天、汽车制造、汽车零部件、电子、核工业、电器、印刷、医疗制药、物流及军工等行业，致力于为客户提供专业的视觉检测设备和解决方案。公司拥有强大的技术团队，集光，机，电，软，算为一体，具有多项国家新型实用专利和发明专利。
        </div>
      </div>

      <base-title title="核心技术领域" rich-title="core technology" class="title-box"></base-title>
      <div class="desc-tips">零件尺寸测量、缺陷检测（通用尺寸检测软件平台）</div>
      <div class="case-image app-flex-mid-center">
        <img src="../../../assets/area/vis2.png" class="case-icon" />
      </div>

      <div class="desc-tips">异形件三维检测</div>
      <div class="case-image app-flex-mid-center">
        <img src="../../../assets/area/vis3.png" class="case-icon" />
      </div>

      <div class="desc-tips">标签、条形码类CCD检测</div>
      <div class="case-image app-flex-mid-center">
        <img src="../../../assets/area/vis4.png" class="case-icon" />
      </div>

      <div class="desc-tips">机械臂视觉引导定位及配套软件</div>
      <div class="case-image app-flex-mid-center">
        <img src="../../../assets/area/vis5.png" class="case-icon" />
      </div>
    </div>

    <base-foot></base-foot>
  </div>
</template>

<script>
import BaseText from '../components/BaseText.vue'
import BaseTitle from '../components/BaseTitle.vue'
import BaseFoot from '../components/BaseFoot.vue'

export default {
  name: 'VisionPage',
  components: {
    BaseText,
    BaseTitle,
    BaseFoot
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.vision-page {
  width: 100%;
  .header-wrap {
    position: relative;
    .image-wrap {
      width: 100%;
      height: 664px;
      overflow: hidden;
      .bg {
        height: 664px;
        width: auto;
      }
    }
    .text-wrap {
      position: absolute;
    }
  }

  .main {
    padding: 0px 255px 190px;
    .desc-cont {
      margin-top: 40px;
      .article-section {
        color: #4c4c4c;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 47px;
        text-indent: 48px;
        &:not(:last-child) {
          margin-bottom: 70px;
        }
      }
    }
    .title-box {
      margin-top: 195px;
    }
    .desc-tips {
      margin: 70px 0px 20px;
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 43px;
    }
    .case-image {
      width: 100%;
      height: 600px;
      overflow: hidden;
      .case-icon {
        height: inherit;
        width: auto;
      }
    }
  }
}
</style>
